import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';
import { FORM_NAME } from '../Passengers/form';
import { getProp } from '../../utilities';

import { sectorsOfAllConnectionsByIdSelector } from '../Connections/selectors';

const poolingDomainSelector = state => state.pooling;
const stepperDetailDomainSelector = state => state.stepper;
const seatingsDomainSelector = state => state.seatings;
const connectionParamsDomainSelector = state => state.connectionParams;

export const isFreeSeatingSelector = createSelector(
  poolingDomainSelector,
  stepperDetailDomainSelector,
  connectionParamsDomainSelector,
  sectorsOfAllConnectionsByIdSelector,
  getFormValues(FORM_NAME),
  (substate, stepper, connectionParams, sectors, passengerFormData) => {
    let sectorIsFull = [];
    let pass = 0;
    const passengers = getProp(passengerFormData, ['passengers'], []);
    if (passengers) {
      pass = passengers.length;
    } else {
      pass = getProp(connectionParams, ['count'], 0);
    }
    const spaceInBusses = getProp(substate, ['isFree'], {});
    Object.keys(spaceInBusses).forEach(id => {
      if (parseInt(spaceInBusses[id], 10) < pass) {
        sectorIsFull = [...sectorIsFull, { ...sectors[id] }];
      }
    });
    return sectorIsFull;
  },
);

export const seatingsSelector = createSelector(
  stepperDetailDomainSelector,
  seatingsDomainSelector,
  sectorsOfAllConnectionsByIdSelector,
  (substate, seatings, sectors) => {
    let isSeatingOk = [];
    const seatsById = getProp(seatings, ['seatsById'], {});
    const reservations = getProp(substate, ['stepParams', 'reservations'], {});
    Object.keys(reservations).forEach(id => {
      Object.keys(reservations[id]).forEach(i => {
        const res = getProp(reservations, [id, i], []);
        if (res.length > 0) {
          const seatsInBus = getProp(seatsById, [i], false);
          if (seatsInBus) {
            const bySeatId = Object.keys(seatsInBus.position).reduce(
              (p, row) => {
                return {
                  ...p,
                  ...Object.keys(seatsInBus.position[row]).reduce(
                    (prew, seat) => {
                      if (seatsInBus.position[row][seat].seatId) {
                        return {
                          ...prew,
                          [seatsInBus.position[row][seat].seatId]: {
                            available: seatsInBus.position[row][seat].available,
                          },
                        };
                      }
                      return { ...prew };
                    },
                    {},
                  ),
                };
              },
              {},
            );
            res.forEach(seat => {
              if (!bySeatId[seat].available) {
                isSeatingOk = [...isSeatingOk, { ...sectors[id], seat }];
              }
            });
          }
        }
      });
    });
    return isSeatingOk;
  },
);



// WEBPACK FOOTER //
// ./src/containers/Pooling/selectors.js